module.exports = __webpack_public_path__ + "static/img/salon_law_zh.35f7ff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salon_law_zh.png
// module id = UUJe
// module chunks = 34